<template>
  <header style="z-index: 5">
    <v-toolbar
      id="toolbarHeader"
      app
      class="elevation-0"
      color="transparent"
      :clipped-left="$vuetify.breakpoint.mdAndUp"
    >
      <!-- :color="computedColor"
            <v-toolbar-side-icon
                    class="hidden-md-and-up"
                    @click.stop="$store.commit('drawer')">
            </v-toolbar-side-icon>
            -->
      <v-toolbar-items absolute>
        <v-btn flat @click.stop="push({ name: 'home' })">
          <v-toolbar-title> Scouts 284 </v-toolbar-title>
        </v-btn>
        <!-- <v-btn
          flat
          v-for="(item, index) in items"
          :key="index"
          v-if="
            item.name !== 'home' &&
            item.tab !== false &&
            (item.name === 'secretaria' ? $store.getters.isSecretaria : true)
          "
          :style="{
            fontWeight: index === position ? 500 : 400,
            textTransform: 'capitalize',
          }"
          @click.stop="push(item)"
        >
          {{ item.name }}
        </v-btn> -->

        <v-btn
          flat
          v-if=" $store.getters.isSecretaria"
          :style="{
            fontWeight: 400,
            textTransform: 'capitalize',
          }"
          @click.stop="push({name: 'secretaria'})"
        >
          secretaría
        </v-btn>

        <v-btn
          flat
          v-if="$store.getters.isScouter"
          :style="{
            fontWeight: index === position ? 500 : 400,
            textTransform: 'capitalize',
          }"
          @click.stop="
            $router.push({
              name: 'listados',
              params: { unidad: $store.getters.getUnidad },
            })
          "
        >
          {{ $store.getters.getUnidad }}
        </v-btn>

        <v-btn
          flat
          v-if="$store.getters.isAuth"
          style="font-weight: 400; text-transform: capitalize"
          @click.stop="push({ name: 'logout' })"
        >
          Cerrar sesión
        </v-btn>
        <!-- <v-btn
          flat
          v-else
          style="font-weight: 400; text-transform: capitalize"
          @click.stop="push({ name: 'login' })"
        >
          Iniciar sesión
        </v-btn> -->
      </v-toolbar-items>
      <v-spacer></v-spacer>

      <!-- <v-menu
        bottom
        offset-y
        :close-on-content-click="false"
        :nudge-width="200"
        v-if="false"
        :v-model="profileMenu"
      >
        <v-btn
          slot="activator"
          fab
          da
          rk
          small
          style="display: none"
          class="elevation-0"
          :style="{
            backgroundColor: profileMenu ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0)',
          }"
          @mouseover="profileMenu = true"
          @mouseout="profileMenu = false"
        >
          <v-avatar
            class="elevation-2"
            :size="utils.isMobile ? '36px' : '42px'"
            @click.stop="push({ name: 'home' })"
          >
            <img
              :src="this.$store.getters.getUser.image"
              style="object-fit: cover"
              :alt="this.$store.getters.getUser.name"
            />
          </v-avatar>
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img :src="this.$store.getters.getUser.image" alt="John" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>John Leider</v-list-tile-title>
                <v-list-tile-sub-title>Scouter Chikay</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon>
                  <v-icon>favorite</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-tile>
              <v-list-tile-action>
                <v-switch color="purple"></v-switch>
              </v-list-tile-action>
              <v-list-tile-title>Enable messages</v-list-tile-title>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-switch color="purple"></v-switch>
              </v-list-tile-action>
              <v-list-tile-title>Enable hints</v-list-tile-title>
            </v-list-tile>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="profileMenu = false">Cancel</v-btn>
            <v-btn color="primary" flat @click="profileMenu = false"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu> -->
    </v-toolbar>
  </header>
</template>

<script>
import items from "../../router/tabs.js";
import utils from "../../utils";
export default {
  props: { active: String },
  data() {
    return {
      utils: utils,
      items: items,

      profileMenu: false,
      clipped: false,
      fixed: false,

      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Scouts 284",
    };
  },
  methods: {
    push: function (param) {
      this.$router.push(param);
    },
  },
  computed: {
    position() {
      var item = this.items.filter((item) => {
        return item.name === this.active;
      })[0];
      return this.items.indexOf(item);
    },
    computedColor() {
      return this.items[this.position].color;
    },
  },
  created: function () {
    // `this` points to the vm instance
    console.log("created");
  },
  mounted: function () {
    console.log("mounted");
  },
  updated: function () {
    console.log("updated");
  },
};
</script>
